import React, { useState } from 'react'

import InputSection from '../../views/Input'
import OutputSection from '../../views/Output'
import IllustrationSection from '../../views/Illustration'

import { MOBILE_NAVIGATION_BTN, SECTION_PANEL } from '../../../../utils/constants'
import { RenderIf } from '../../../../utils/fns'
import { useSelector } from 'react-redux'
import { getGlobalSettingsState } from '../../../../utils/selectors'

const Views = {
  [SECTION_PANEL.INPUT]: (props) => <InputSection {...props} />,
  [SECTION_PANEL.OUTPUT]: (props) => <OutputSection {...props} />,
  [SECTION_PANEL.ILLUSTRATION]: (props) => <IllustrationSection {...props} />,
}

const MobileView = () => {
  const isEulaAccepted = useSelector((state) => getGlobalSettingsState(state).isEulaAccepted)

  const [screen, setScreen] = useState(SECTION_PANEL.INPUT)

  const handleNavigation = (value) => setScreen(value)
  return (
    <React.Fragment>
      {Object.entries(Views).map(([key, View]) => (
        <View key={key} style={{ display: key === screen ? 'block' : 'none' }} />
      ))}

      <div className="workspaceButtonGroup">
        {RenderIf(
          isEulaAccepted,
          <button className="button -fab resetApp" onClick={() => window.location.reload()}>
            <span className="material-icons">refresh</span>
          </button>,
        )}

        {MOBILE_NAVIGATION_BTN.map((item) => (
          <button
            type="button"
            key={item.value}
            value={item.value}
            className="button -fab inputOutputSelect"
            onClick={() => handleNavigation(item.value)}
            disabled={screen === item.value || !isEulaAccepted}
          >
            {item.label}
          </button>
        ))}
      </div>
    </React.Fragment>
  )
}

export default MobileView
